import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import SentCampaignsLog from "./SentCampaignsLog";
import SentUniversityCoursesLog from "./SentUniversityCoursesLog";
import CourseAuditLog from "./CourseAuditLog";
import SimAuditLog from "./SimAuditLog";

const TabPanel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const Logs = () => {
    const [topTab, setTopTab] = useState(0);
    const [activityTab, setActivityTab] = useState(0);
    const [emailsTab, setEmailsTab] = useState(0);

    return (
        <Box sx={{ p: 3 }}>
            <Tabs
                value={topTab}
                onChange={(e, newVal) => setTopTab(newVal)}
            >
                <Tab label="Activity" />
                <Tab label="Emails" />
            </Tabs>

            <TabPanel value={topTab} index={0}>
                <Tabs
                    value={activityTab}
                    onChange={(e, newVal) => setActivityTab(newVal)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Sent Campaigns" />
                    <Tab label="Sent University Courses" />
                </Tabs>
                <TabPanel value={activityTab} index={0}><SentCampaignsLog /></TabPanel>
                <TabPanel value={activityTab} index={1}><SentUniversityCoursesLog /></TabPanel>
            </TabPanel>

            <TabPanel value={topTab} index={1}>
                <Tabs
                    value={emailsTab}
                    onChange={(e, newVal) => setEmailsTab(newVal)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Course Audit Logs" />
                    <Tab label="Simulation Audit Logs" />
                </Tabs>
                <TabPanel value={emailsTab} index={0}><CourseAuditLog /></TabPanel>
                <TabPanel value={emailsTab} index={1}><SimAuditLog /></TabPanel>
            </TabPanel>
        </Box>
    );
};

export default Logs;
